export default {
  '0-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct: 'This is a sample text.',
        errorType: 'modAcc',
        context: { length: 23, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            '#@-@# THis',
            '#@+@# This',
            'is  a',
            '#@-@# samplee',
            '#@+@# sample',
            'text.',
          ],
        ],
        highlights: [
          {
            wrong: 'THis',
            offset: 0,
            replace: 'This',
            length: 4,
            model: 'accuracy',
            tread_id: '0-A-0',
          },
          {
            wrong: 'samplee',
            offset: 10,
            replace: 'sample',
            length: 7,
            model: 'accuracy',
            tread_id: '0-A-0',
          },
        ],
        length: 23,
        offset: 0,
        wrong: 'THis is a samplee text.',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '0-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [],
    readability: 6,
    errors: {
      SpellError: 0,
      Suggestion: 0,
      GrammarError: 0,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 0,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 1,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '0-A',
    text_details: {
      characters: 23,
      words: 5,
      speaking_time: 2,
      reading_time: 1,
      readability: 6,
    },
  },
  '1-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct:
          'GrammarIn will detect your mistakes using its AI and helps you write better.',
        errorType: 'modAcc',
        context: { length: 78, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            'GrammarIn',
            '#@-@# wills',
            '#@+@# will',
            '#@-@# detected',
            '#@+@# detect',
            '#@-@# you',
            '#@+@# your',
            'mistakes',
            '#@-@# usng',
            '#@+@# using',
            'its  AI  and  helps',
            '#@-@# your',
            '#@+@# you',
            'write  better.',
          ],
        ],
        highlights: [
          {
            wrong: 'wills detected you',
            offset: 10,
            replace: 'will detect your',
            length: 18,
            model: 'accuracy',
            tread_id: '1-A-0',
          },
          {
            wrong: 'usng',
            offset: 38,
            replace: 'using',
            length: 4,
            model: 'accuracy',
            tread_id: '1-A-0',
          },
          {
            wrong: 'your',
            offset: 60,
            replace: 'you',
            length: 4,
            model: 'accuracy',
            tread_id: '1-A-0',
          },
        ],
        length: 78,
        offset: 0,
        wrong:
          'GrammarIn wills detected you mistakes usng its AI and helps your write better.',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '1-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [],
    readability: 18,
    errors: {
      SpellError: 0,
      Suggestion: 0,
      GrammarError: 0,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 0,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 1,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '1-A',
    text_details: {
      characters: 78,
      words: 13,
      speaking_time: 6,
      reading_time: 3,
      readability: 18,
    },
  },
  '2-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct:
          'He walked to the market yesterday and bought some fruits. The apple was very sweet, but she did not eat it.',
        errorType: 'modAcc',
        context: { length: 95, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            '#@-@# he',
            '#@+@# He',
            '#@-@# walk',
            '#@+@# walked',
            'to',
            '#@+@# the',
            'market  yesterday  and',
            '#@-@# buyed',
            '#@+@# bought',
            'some  fruits.',
            '#@-@# the',
            '#@+@# The',
            'apple  was  very',
            '#@-@# sweet',
            '#@+@# sweet,',
            'but  she',
            '#@+@# did',
            'not  eat  it.',
          ],
        ],
        highlights: [
          {
            wrong: 'he walk',
            offset: 0,
            replace: 'He walked',
            length: 7,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
          {
            wrong: 'market',
            offset: 11,
            replace: 'the market',
            length: 6,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
          {
            wrong: 'buyed',
            offset: 32,
            replace: 'bought',
            length: 5,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
          {
            wrong: 'the',
            offset: 51,
            replace: 'The',
            length: 3,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
          {
            wrong: 'sweet',
            offset: 70,
            replace: 'sweet,',
            length: 5,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
          {
            wrong: 'not',
            offset: 84,
            replace: 'did not',
            length: 3,
            model: 'accuracy',
            tread_id: '2-A-0',
          },
        ],
        length: 95,
        offset: 0,
        wrong:
          'he walk to market yesterday and buyed some fruits. the apple was very sweet but she not eat it.',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '2-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [],
    readability: 16,
    errors: {
      SpellError: 0,
      Suggestion: 0,
      GrammarError: 0,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 0,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 1,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '2-A',
    text_details: {
      characters: 95,
      words: 19,
      speaking_time: 9,
      reading_time: 5,
      readability: 16,
    },
  },
  '3-A': {
    modMtch: [],
    accMode: [
      {
        errorHeading: 'Accuracy - Change the Wrong for more than three',
        correct:
          'We go to the park every Sunday. They are playing with their ball now.',
        errorType: 'modAcc',
        context: { length: 67, offset: 0 },
        message: 'Try Rewriting for Clarity',
        replacements: [
          [
            '#@-@# we  goes',
            '#@+@# We  go',
            'to',
            '#@+@# the',
            'park  every',
            '#@-@# sundays.',
            '#@+@# Sunday.',
            '#@-@# they',
            '#@+@# They',
            '#@-@# is',
            '#@+@# are',
            'playing  with',
            '#@-@# there',
            '#@+@# their',
            'ball  now.',
          ],
        ],
        highlights: [
          {
            wrong: 'we goes',
            offset: 0,
            replace: 'We go',
            length: 7,
            model: 'accuracy',
            tread_id: '3-A-0',
          },
          {
            wrong: 'park',
            offset: 11,
            replace: 'the park',
            length: 4,
            model: 'accuracy',
            tread_id: '3-A-0',
          },
          {
            wrong: 'sundays. they is',
            offset: 22,
            replace: 'Sunday. They are',
            length: 16,
            model: 'accuracy',
            tread_id: '3-A-0',
          },
          {
            wrong: 'there',
            offset: 52,
            replace: 'their',
            length: 5,
            model: 'accuracy',
            tread_id: '3-A-0',
          },
        ],
        length: 67,
        offset: 0,
        wrong:
          'we goes to park every sundays. they is playing with there ball now.',
        Color: '#E82D53',
        ColorLight: '#FFDDDD',
        UnderLine: 'SolidLine',
        rule: {
          category: { id: 'GINMods', name: 'GINMods' },
          description: 'GINMods',
          id: 'GINMods',
          issueType: 'modAcc',
        },
        model: 'accuracy',
        ChkiD: '3-A-0',
      },
    ],
    clrMode: [],
    syMode: [],
    sentiMode: [],
    algMode: [],
    readability: 12,
    errors: {
      SpellError: 0,
      Suggestion: 0,
      GrammarError: 0,
      redundency: 0,
      clarity: 0,
      accuracy: 0,
      style: 0,
      syntax: 0,
      vocabulary: 0,
      modelsuggestions: 0,
      accuracy_suggestions: 1,
      clarity_suggestions: 0,
      style_suggestions: 0,
    },
    ChkiD: '3-A',
    text_details: {
      characters: 67,
      words: 13,
      speaking_time: 6,
      reading_time: 3,
      readability: 12,
    },
  },
};
